__webpack_require__.p = "https://btc.dev4.glprotocol.com/";